import { Badge, Box, Flex, Text, getPaletteColor } from 'pcln-design-system'
import React from 'react'
import styled from 'styled-components'

const StrikeThroughPrice = styled(Box)`
  position: relative;
  display: inline-block;
  &:before {
    content: '';
    width: 90%;
    position: absolute;
    right: 0;
    top: 48%;
    border-bottom: 1px solid ${getPaletteColor('text.dark')};
    transform: skewY(-10deg);
  }
`

function PriceRow({ currencySymbol = '$', price, priceBadge, priceType, savingsDisplay, strikePrice }) {
  return (
    <Flex alignItems='center' justifyContent='space-between' pb={2} px={3}>
      <Flex flexDirection='column' width='fit-content'>
        <Box width='100%'>
          <Badge bg='highlight.light' color='highlight.dark'>
            <Text textStyle='highlightBold'>{priceBadge}</Text>
          </Badge>
        </Box>
        <Text color='text.light' textStyle='caption' pt={1}>
          {savingsDisplay}
        </Text>
      </Flex>
      <Flex flexDirection='column'>
        {strikePrice && (
          <Flex alignItems='flex-start' justifyContent='right'>
            <Text color='text.dark' pr='2px' mt='1px' fontWeight='bold' fontSize='8px'>
              {currencySymbol}
            </Text>
            <StrikeThroughPrice>
              <Text color='text.dark' textAlign='right' textStyle='captionBold'>
                {strikePrice}
              </Text>
            </StrikeThroughPrice>
          </Flex>
        )}
        <Flex alignItems='flex-start' justifyContent='right'>
          <Flex>
            <Text color='pricePrimary.base' mt='2px' pr='2px' textStyle='captionBold'>
              {currencySymbol}
            </Text>
          </Flex>
          <Text color='pricePrimary.base' textAlign='right' textStyle='heading4'>
            {price}
          </Text>
        </Flex>
        <Text color='text.light' textAlign='right' textStyle='caption'>
          {priceType}
        </Text>
      </Flex>
    </Flex>
  )
}

export default PriceRow
